<template>
  <div class="home">
    <mynav1 :data='nvdata'></mynav1>
    <!-- <imgct ></imgct> -->
    <div v-if="true" id="schoolct">
      <div id="smd1">
        <div>社保卡”校园全业务场景解决方案  </div>
      </div>
      <div id="smd2">
        <div>目标与价值</div>
      </div>
      <div id="smd3">
        <div>“社保卡”校园全业务场景解决方案实施方式</div>
      </div>
      <div id="smd41" v-show="m4index==0">
        <div>应用场景说明示例</div>
        <img @click="m4index=1" :src="require('../assets/pic/solve/school/bg4i1.jpg')" />
      </div>
      <div id="smd42" v-show="m4index==1">
        <div>应用场景说明示例</div>
        <img @click="m4index=2" :src="require('../assets/pic/solve/school/bg4i1.jpg')" />
      </div>
      <div id="smd43" v-show="m4index==2">
        <div>应用场景说明示例</div>
        <img @click="m4index=0" :src="require('../assets/pic/solve/school/bg4i2.jpg')" />
      </div>
      <div id="smd5">
        <div>方案版本</div>
      </div>
    </div>
    
    <myfooter :data='ftdata'></myfooter>
  </div>
</template>

<style>
#schoolct {
  background: white;
}

#smd1 {
  height: 9rem;
  background-image: url('../assets/pic/solve/school/bg1.jpg');
  background-size: 100% 100%;
  overflow: hidden;
}
#smd1 div {
  font-size: .6rem;
  font-weight: normal;
  text-align: center;
  color: white;
  margin-top: 4.1rem;
}

#smd2 {
  height: 9rem;
  background-image: url('../assets/pic/solve/school/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#smd2 div {
  font-size: .36rem;
  font-weight: normal;
  color: white;
  margin-top: 1.24rem;
  margin-left: 3.85rem;
}

#smd3 {
  height: 9rem;
  background-image: url('../assets/pic/solve/school/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#smd3 div {
  font-size: .36rem;
  font-weight: normal;
  color: white;
  text-align: center;
  margin-top: 1.1rem;
}

#smd41 img,#smd42 img,#smd43 img {
  width: .98rem;
  height: .32rem;
  display: inline-block;
  cursor: pointer;
}

#smd41 {
  height: 9rem;
  background-image: url('../assets/pic/solve/school/bg41.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#smd41 div {
  font-size: .36rem;
  font-weight: normal;
  color: #FFFFFF;
  margin-top: .9rem;
  margin-left: 3.92rem;
}
#smd41 img {
  margin-left: 3.92rem;
  margin-top: 6rem;
}

#smd42 {
  height: 9rem;
  background-image: url('../assets/pic/solve/school/bg42.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#smd42 div {
  font-size: .36rem;
  font-weight: normal;
  color: white;
  margin-top: .9rem;
  margin-left: 11.49rem;
}
#smd42 img {
  margin-left: 11.49rem;
  margin-top: 6.2rem;
}

#smd43 {
  height: 9rem;
  background-image: url('../assets/pic/solve/school/bg43.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#smd43 div {
  font-size: .36rem;
  font-weight: normal;
  color: white;
  margin-top: .62rem;
  margin-left: 3.9rem;
}
#smd43 img {
  margin-left: 3.92rem;
  margin-top: 6.5rem;
}

#smd5 {
  height: 9rem;
  background-image: url('../assets/pic/solve/school/bg5.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#smd5 div {
  font-size: .36rem;
  font-weight: bold;
  color: #4A4A4A;
  text-align: center;
  margin-top: 1.08rem;
}

</style>

<script>
// @ is an alias to /src
require('@/assets/zt.css')
import mynav1 from '@/components/mynav1'
import myfooter from '@/components/footer'
// import imgct from '@/components/solve/school'




export default {
  components: {
    mynav1,myfooter
  },
  data () {
    return {
      m4index: 0,
      ovscroll: false,
      scrdist: 0,
      ftdata: {
        type: 'product',
        lcallback: () => {
          this.init()
        }
      },
      nvdata: {
        sindex: 1,
        type: 'solution',
        lcallback: (stype,sstype) => {
          this.setHead(stype,sstype)
        }
      }
   
    }
  },
  computed: {
  
  },
  methods: {

    onPageScroll (dist) {
      this.ovscroll = dist>93?true:false
      if (dist - this.scrdist > 93) {
        this.scrdist = dist
      } else if (dist < this.scrdist) {
        this.scrdist = dist
      }
      if (dist>0) this.ismenu=false
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/20 + 'px'; /// 20
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem()

      var _this = this
      // var index = 1
      window.onscroll = function (e) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        _this.onPageScroll(scrollTop)
      }
    },
  
    init () {
      var stype = this.$route.query.stype?this.$route.query.stype:''
      this.setHead(stype)
    }
  },
  mounted () {
    this.initWindowEv()
    this.init()
  }
}
</script>
